module.exports = "<div class=\"main-container\" class=\"root_tree\">\r\n  <div class=\"node-container\" (drop)=\"addList($event)\" (dragover)=\"dragOver($event)\">\r\n      <app-accordion #treeAccordion class=\"accordion\" [isEdit]=\"isEdit\" [nodes]=\"lists\" [header]=\"header\" [isEnable]=\"isEnable\" [selectList]=\"this\">\r\n      </app-accordion>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/select-list/select-list.component.html
// module id = ../../../../../src/app/core/components/select-list/select-list.component.html
// module chunks = main